import { Injectable } from '@angular/core';

import { Observable, catchError } from 'rxjs';

import { ApiTemplate, ApiResponse, RequestOptions, TemplateHelper } from '@venecia/apis/base';

import { OAuthClientRequest } from './model/oauth-client-request.model';
import { OAuthClientResponse } from './model/oauth-client-response.model';

@Injectable({ providedIn: 'root' })
export class OAuthClientsApi extends ApiTemplate<OAuthClientResponse, OAuthClientRequest> {
  constructor() {
    super('http.rest.auth.url', '/api/oauth/clients');
  }

  findByClientId(clientId: string, options?: RequestOptions): Observable<ApiResponse<OAuthClientResponse>> {
    return this.getByPath(clientId, options);
  }

  enable(id: number, options?: RequestOptions): Observable<void> {
    return this.putAction(`${id}/enable`, options);
  }

  disable(id: number, options?: RequestOptions): Observable<void> {
    return this.putAction(`${id}/disable`, options);
  }

  deleteById(id: number, options?: RequestOptions): Observable<void> {
    return this.delete(id, options);
  }

  private putAction(path: string, options?: RequestOptions): Observable<void> {
    const url = this.urlBuilder!.build(path);
    const httpOptions = TemplateHelper.buildOptions(options);

    return this.http
      .put<void>(url, null, httpOptions)
      .pipe(
        TemplateHelper.applyRetry(options),
        catchError((err) => TemplateHelper.handleError(err)),
      );
  }
}
